import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { formatData, getUserNameToName, isNullOrEmpty, showMessageToast, translate } from '../../../../utils/util';
import ContainerService from '../../../../services/ContainerService';
import { Breadcrumbs, Input, Button, Table, Card } from '../../../../components/UI/ComponentsUI'
import { onValueChange, validateInputsRequired } from '../../../../utils/handleChangeHooks';

const ChangeDatesContainer = (props) => {
    const [edit, setEdit] = useState(false);
    const [selectedItem, setSelectedItem] = useState();
    const [currentPage, setCurrentPage] = useState({ pageSize: 10, pageIndex: 0, sortField: "updatedOn", sortOrder: -1 });
    const [data, setData] = useState([]);
    const [filter, setFilter] = useState({});

    const onChangeFilter = (event) => {
        onValueChange(event, filter, setFilter);
    };

    useEffect(() => {
        search(false);
        // eslint-disable-next-line
    }, [currentPage]);

    const search = (click) => {
        props.getDatesContainer({
            ...filter,
            sortField: currentPage.sortField,
            sortOrder: currentPage.sortOrder,
            PageSize: currentPage.pageSize,
            PageIndex: click ? 0 : currentPage.pageIndex
        }, (response) => {
            setEdit(false);
           
            if (response) {
                setData([...response.items]);

            }
        });
    };

    const formatDate = (date, includeTime = false) => {
        if (!(date instanceof Date)) date = new Date(date);

        const yyyy = date.getFullYear();
        const mm = String(date.getMonth() + 1).padStart(2, '0');
        const dd = String(date.getDate()).padStart(2, '0');

        if (!includeTime) {
            return `${yyyy}-${mm}-${dd}`;
        }

        const hh = String(date.getHours()).padStart(2, '0');
        const min = String(date.getMinutes()).padStart(2, '0');

        return `${yyyy}-${mm}-${dd}T${hh}:${min}`;
    };

    const onChangeItem = (event) => {
        onValueChange(event, selectedItem, setSelectedItem);
    };

    const configColumns = () => {
        return [
            {
                field: 'name',
                body: (rowData) => rowData.container?.name || '',
                header: 'Nome Container',
                align: 'left',
                sortable: true
            },
            {
                field: 'containerStatusDescription',
                header: 'Status Atual',
                align: 'left',
                sortable: true
            },
            {
                field: 'order',
                body: (rowData) => rowData.containerStatus?.order,
                header: 'Ordem Status',
                align: 'left',
                sortable: true
            },
            {
                field: 'referenceDate',
                body: (rowData) => {
                 
                    const isEditing = edit && selectedItem?.id === rowData.id;

                    if (isEditing) {
                        return (
                            <Input
                                key={`input-${rowData.id}`}
                                id="referenceDate"
                                name="referenceDate"
                                type="datetime-local"
                                required
                                value={formatDate(selectedItem.referenceDate || selectedItem.createdOn, true)}
                                onChange={onChangeItem}
                            />
                        );
                    }

                    return formatData(rowData?.referenceDate || rowData?.createdOn);
                },
                header: 'Data Referência',
                align: 'left',
                sortable: false
            },
               {
                field: 'createdOn',
                header: 'Data Modificação',
                body: (rowData) =>
                 formatData(rowData.createdOn),
                align: 'left',
                sortable: true
            },
            {
                field: 'createdBy',
                header: 'Usuário Modificação',
                body: (rowData) =>
                    getUserNameToName(props?.usersFromElog, rowData.createdBy),
                align: 'left',
                sortable: true
            }
        ];
    };

    const onSelectChange = (item) => {
        setSelectedItem(item);
    }

    const configActions = () => [
        {
            function: (row) => (
                <i className="material-icons sixth-text-color"
                    onClick={() => {
                        if (selectedItem?.id === row.id) {
                            const data = {
                                id: selectedItem.container.id,
                                status: selectedItem.containerStatusId,
                                updatedOn: selectedItem.referenceDate
                            }
                             
                            props.updateDatesContainer(data,
                                () => {
                                    setData([]);
                                    setEdit(false);
                                    setSelectedItem();
                                    search(false); // atualiza dados primeiro
                                }
                            )
                        } else {
                            setEdit(true)
                            onSelectChange(row)
                        }
                    }}
                    style={{ fontSize: '1.85rem', cursor: 'pointer', color: 'green' }}>
                    {selectedItem?.id === row.id ? 'save' : 'edit'}</i>

            )
        }
    ];

    return (
        <div>
            <Breadcrumbs
                title={{
                    icon: 'mdi mdi-calendar-month',
                    label: translate('container:storage:menu.change-dates-container')
                }}
            />
            <div className="container-fluid" style={{ marginTop: '30px', marginBottom:'10px' }}>
                <div className="container" style={{ marginTop: '0px' }}>
                    <Card>
                        <div id="getChange" className="col s12">
                            <div className="row" style={{ padding: '10px' }}>
                                <div className="input-field no-padding col s6">
                                    <Input
                                        id="name"
                                        name="name"
                                        label="Num. Container"
                                        required={isNullOrEmpty(filter?.mvmNumber)}
                                        type="text"
                                        value={filter?.name || ''}
                                        onChange={onChangeFilter}
                                    />
                                </div>
                                <div className="input-field no-padding col s5">
                                    <Input
                                        required={isNullOrEmpty(filter?.name)}
                                        id="mvmOrBoarding"
                                        name="mvmNumber"
                                        label="Mvm ou Viagem"
                                        type="text"
                                        value={filter?.mvmNumber || ''}
                                        onChange={onChangeFilter}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="row" style={{ paddingTop: '5px' }}>
                            <Button full="true" text="Buscar" onClick={search} />
                        </div>
                    </Card>
                </div>

            </div>
            {data.length > 0 &&  
            <div id="items" className="container-fluid">                   
                <Table
                    key="tableDatesContainer"
                    totalPages={0}
                    current={{ currentPage, setCurrentPage }}
                    col={configColumns()}
                    data={data}
                    actions={configActions()}
                />
            </div>}
        </div>
    );
};

const mapStateToProps = (state) => ({
    usersFromElog: state.usersElogReducer.usersElog,
    user: state.userReducer.user
});

const mapDispatchToProps = (dispatch) => ({
    updateDatesContainer: (data, callback) => {
        dispatch(ContainerService.updateDatesContainer(data, callback));
    },
    getDatesContainer: (filter, callback) => {
        dispatch(ContainerService.getDatesContainer(filter, callback));
    }
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ChangeDatesContainer));
